<span #trigger="cdkOverlayOrigin"
      (pointerenter)="isOpen = true"
      (pointerleave)="isOpen = false"
      (pointerup)="handlePointerUp($event)"
      cdkOverlayOrigin class="disable-text-selection">
    <ng-content select="tooltip-body"></ng-content>
</span>
<ng-template
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayOrigin]="trigger"
  cdkConnectedOverlay>
  <ng-content select="tooltip-popout"></ng-content>
</ng-template>
